import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { RmLogsResp } from './types';

// GET /v1/rmlogs — runtime sessions + last 30 days of operation log entries.
// Backed by internal/handler/v1/rmlog/get.go; the request also bumps the
// server-side heartbeat that distinguishes a running session from a crash.
//
// staleTime is short (15s) so the page feels live when an admin keeps it
// open during a deploy / restart, but we don't hammer the heartbeat
// endpoint on every focus change.
export function useRmLogs() {
  return useQuery({
    queryKey: ['rmlogs'],
    queryFn: () => api<RmLogsResp>('/v1/rmlogs'),
    refetchOnWindowFocus: true,
    staleTime: 15_000,
  });
}
